import axios, { type AxiosInstance } from 'axios';
import { attachErrorInterceptor } from '@/api/interceptors/errorInterceptor';

export function createApiInstance(baseURL: string): AxiosInstance {
  const instance = axios.create({
    baseURL,
    timeout: 30_000,
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'product-id':"1000", 'tenant-id':"1", 'platform':"web" },
  });

  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("TOKEN");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  attachErrorInterceptor(instance);

  return instance;
}
